import React from 'react';
import { Navigate } from 'react-router-dom';

// Wraps the various Routes in order to manage access based of privilege
const ProtectedRoute = ({ allowedRoles, allowedModuleKey, role, modules, children }) => {
    // Log the role, modules, and allowedModuleKey
    // console.log('Role:', role);
    // console.log('Modules:', modules);
    // console.log('Allowed Module Key:', allowedModuleKey);

    // Check if the role is allowed
    const hasRoleAccess = allowedRoles.includes(role);
    // console.log('Has Role Access:', hasRoleAccess);

    // If allowedModuleKey is provided, check for module access
    const hasModuleAccess = (() => {
        if (!allowedModuleKey) {
            return true;
        }

        const moduleEntry = modules?.[allowedModuleKey];
        const permissionKey = allowedModuleKey.split('Module')[0].toLowerCase();

        if (moduleEntry && Object.prototype.hasOwnProperty.call(moduleEntry, permissionKey)) {
            return moduleEntry[permissionKey] === true;
        }

        // Owners/Admins can access when module privileges are not provisioned yet
        if (role === 900 || role === 101) {
            return true;
        }

        return false;
    })();


    // console.log('Has Module Access:', hasModuleAccess);

    if (hasRoleAccess && hasModuleAccess) {
        return children;
    }

    return <Navigate to="/404" replace />;
};

export default ProtectedRoute;
